import React from "react";

const Close = () => {
	return (
		<>
			<svg width={22} height={22} x={0} y={0} viewBox="0 0 512 512">
				<g>
					<g id="_02_User" data-name="02 User">
						<path
							d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"
							fill="#ffffff"
							data-original="#ffffff"
						/>
						<path
							d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"
							fill="#ffffff"
							data-original="#ffffff"
						/>
					</g>
				</g>
			</svg>
		</>
	);
};

export default Close;
